import {
  buildWorkspaceQuery,
  workspaceRequest,
} from "./workspaceApiShared";

export async function listManagedWorkspaceLeases(token, salonId = null) {
  const suffix = buildWorkspaceQuery({ salon_id: salonId });
  return workspaceRequest(`/workspaces/managed/leases${suffix}`, {
    token,
    fallback: "Unable to load workspace leases.",
  });
}

export async function listWorkspaceLeases(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/leases`, {
    token,
    fallback: "Unable to load workspace leases.",
  });
}

export async function createWorkspaceLease(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/leases`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to create workspace lease.",
  });
}

export async function activateWorkspaceLease(leaseId, token) {
  return workspaceRequest(`/workspaces/leases/${leaseId}/activate`, {
    method: "POST",
    token,
    body: {},
    fallback: "Unable to activate workspace lease.",
  });
}

export async function cancelWorkspaceLease(leaseId, payload, token) {
  return workspaceRequest(`/workspaces/leases/${leaseId}/cancel`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to cancel workspace lease.",
  });
}

export async function terminateWorkspaceLease(leaseId, payload, token) {
  return workspaceRequest(`/workspaces/leases/${leaseId}/terminate`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to terminate workspace lease.",
  });
}
